import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_tile-product-click';
/**
 * An event for when a product tile is clicked.
Parameters: context (deprecated, see below), requestId, productToken, promotedBy

ImpressionId: BE-generated product impression id
screenContext: ProductTileScreen
containerContext: ProductTileScreenContainer
token: screen specific token e.g. query
https:&#x2F;&#x2F;www.notion.so&#x2F;faire&#x2F;Product-Tile-Click-and-Impression-Revamp-Phase-2-38e760e8959749a0a4db905a24e8b134#6cc9995831674b3683cf697cbe66661a
*/
export function trackProductTileProductClick(context_string, requestId_string2, productToken, promotedBy_string3, impressionId_string4, screenContext_string5 = '', containerContext_string6 = '', token_string7 = '') {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            context_string,
            requestId_string2,
            productToken,
            promotedBy_string3,
            impressionId_string4,
            screenContext_string5,
            containerContext_string6,
            token_string7,
        },
    });
}
